export default __webpack_public_path__ + "0497eeb.png";